import { useState } from 'react';
import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import { aboutData } from '@/mocks/about';

const baseUrl = 'https://haosexiaoyi.com';

export default function AboutPage() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();

    if (honeypot) {
      setFormSubmitted(true);
      return;
    }

    const submitAddr = 'https://readdy.ai/api/form/d9qrotnnahb7382oveb0';

    try {
      const submitData = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'phone_alt') {
          submitData.append(key, value as string);
        }
      });

      const response = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: submitData.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '';

      if (response.ok && parsed?.code === 'OK') {
        setFormSubmitted(true);
        form.reset();
      } else {
        setFormError(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
    }
  };

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: aboutData.brandName,
        description: aboutData.intro,
        url: baseUrl,
        email: aboutData.contactEmail,
      },
      {
        '@type': 'WebPage',
        name: `关于我们 - ${aboutData.brandName}`,
        description: aboutData.intro,
        url: `${baseUrl}/about`,
        isPartOf: {
          '@type': 'WebSite',
          name: aboutData.brandName,
          url: baseUrl,
        },
      },
    ],
  };

  return (
    <>
      <SEO
        title="关于我们"
        description={aboutData.intro}
        keywords="关于我们,好色小姨故事集,品牌介绍,都市情感故事平台"
        canonicalUrl={`${baseUrl}/about`}
        schema={schema}
      />
      <Navbar />
      <main className="pt-20 pb-14 md:pb-20 bg-background-50 min-h-screen">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          {/* Brand Intro */}
          <section className="mb-16">
            <div className="text-center max-w-3xl mx-auto mb-12">
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                关于我们
              </h1>
              <p className="text-lg text-foreground-600">{aboutData.tagline}</p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">{aboutData.intro}</p>
                <p className="text-sm text-foreground-700 leading-relaxed">{aboutData.story}</p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {aboutData.stats.map((stat, i) => (
                  <div
                    key={i}
                    className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70"
                  >
                    <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-500">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Values */}
          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
              我们的理念
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {aboutData.values.map((value, i) => (
                <div key={i} className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 rounded-xl flex items-center justify-center bg-accent-100/70 text-accent-500">
                    <i className={`${value.icon} text-xl`}></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-2">{value.title}</h4>
                  <p className="text-xs text-foreground-600 leading-relaxed">{value.description}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Reputation */}
          <section id="reputation" className="mb-16">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
              读者口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {aboutData.testimonials.map((t, i) => (
                <div key={i} className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">"{t.content}"</p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section id="contact" className="max-w-2xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              联系我们
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-8">
              有任何问题或建议？欢迎通过以下方式联系我们，或直接填写表单。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center">
                <div className="w-10 h-10 mx-auto mb-3 rounded-full flex items-center justify-center bg-primary-100/70 text-primary-500">
                  <i className="ri-mail-line"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-900">{aboutData.contactEmail}</div>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center">
                <div className="w-10 h-10 mx-auto mb-3 rounded-full flex items-center justify-center bg-accent-100/70 text-accent-500">
                  <i className="ri-wechat-line"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">微信公众号</div>
                <div className="text-sm font-medium text-foreground-900">{aboutData.contactWechat}</div>
              </div>
            </div>

            {formSubmitted ? (
              <div className="bg-background-100 border border-background-200/70 rounded-xl p-8 text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full flex items-center justify-center bg-primary-100/70 text-primary-500">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mb-2">感谢您的留言！</h3>
                <p className="text-sm text-foreground-600">我们会在 1-2 个工作日内回复您。</p>
              </div>
            ) : (
              <form
                onSubmit={handleSubmit}
                data-readdy-form="true"
                className="bg-background-50 border border-background-200/70 rounded-xl p-6 space-y-4"
              >
                {formError && (
                  <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg p-3">
                    {formError}
                  </div>
                )}

                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1">
                    姓名 <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-white text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                    placeholder="请输入您的姓名"
                  />
                </div>

                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1">
                    邮箱 <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-white text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                    placeholder="请输入您的邮箱"
                  />
                </div>

                <div>
                  <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1">
                    主题
                  </label>
                  <input
                    id="contact-subject"
                    name="subject"
                    type="text"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-white text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                    placeholder="请输入主题"
                  />
                </div>

                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1">
                    留言 <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-white text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                    placeholder="请输入您的留言（最多500字）"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">最多 500 字</p>
                </div>

                <div className="contact-honeypot-container" style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, overflow: 'hidden' }}>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                </div>

                <button
                  type="submit"
                  className="w-full py-3 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
                >
                  提交留言
                </button>
              </form>
            )}
          </section>
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}